import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class PropertyFloorActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Property/PropertyFloor/PropertyFloorBrowser")
	}

	render() {
		return (
			<Activity 
				name="PropertyFloor"
				RenderedComponent={this.RenderedComponent}
				context="PropertyFloor"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(PropertyFloorActivity)
